import { Capacitor } from '@capacitor/core'
import { StatusBar, Style } from '@capacitor/status-bar'

/** Match dark bar UI on iOS (safe to call on web — no-op). */
export async function initNativeShell(): Promise<void> {
  if (!Capacitor.isNativePlatform()) return
  try {
    await StatusBar.setStyle({ style: Style.Light })
    if (Capacitor.getPlatform() === 'android') {
      await StatusBar.setBackgroundColor({ color: '#120e0c' })
    }
  } catch {
    // Plugin optional if OS blocks it
  }
}
